import { isSDK } from '@bingads-webui-campaign-react/sdk-utils';
import { getRoutePathById, allSiteMap } from '@bingads-webui-react/with-site-map';
import { Status } from '@bingads-webui-campaign-react/diagnostic-card';

import { DetailCardsKey } from '../const';
import { statusAndActionReport, auditPointDisplayed, getFullProductUrl } from './utils';

const BILLING_ISSUE_LIST = ['PrepayAccountOutOfBalance', 'AddPaymentInstrument'];
const BANNER_ALERT = 'BannerAlert';
const DANGER = 'danger';

export function getBillingDetail({
  billing,
  i18n,
  scope,
  ccBaseUrl,
  activity,
}) {
  const name = i18n.getString(_TL_('Billing'));
  const key = DetailCardsKey.billing;

  const paymentError = billing.find(notification => notification.alertType === BANNER_ALERT
    && notification.NotificationLevel === DANGER
    && BILLING_ISSUE_LIST.includes(notification.NotificationId));

  if (paymentError) {
    statusAndActionReport({
      activity,
      type: 'billing',
      status: Status.Error,
    });

    auditPointDisplayed({ activity, auditPoint: 'Payment failed', area: 'Payment' });
    return {
      name,
      key,
      status: Status.Error,
      statusLabelMsg: i18n.getString(_TL_('Failed')),
      cardTitle: i18n.getString(_TL_('Payment failed')),
      cardMsg: i18n.getString(_TL_('The previous payment failed. Please make sure your payment method is still valid.')),
      onCardButtonClicked: () => {
        statusAndActionReport({
          activity,
          type: 'billing',
          action: 'navigate to payment methods page',
          details: 'AuditPoint: Payment failed',
        });

        const ccBaseUrlNoTrailingSlash = ccBaseUrl.replace(/\/$/, '');
        if (!isSDK()) {
          const paymentPath = getRoutePathById(allSiteMap, 'paymentMethods');
          scope.remove(['campaignId']);
          scope.save(`${ccBaseUrlNoTrailingSlash}${paymentPath}`);
        } else {
          const url = `${ccBaseUrlNoTrailingSlash}${getFullProductUrl('paymentMethods', scope)}`;
          window.open(url);
        }
      },
      cardButtonText: i18n.getString(_TL_('Check payment method')),
    };
  }

  statusAndActionReport({
    activity,
    type: 'billing',
    status: Status.Active,
  });

  return {
    name,
    key,
    status: Status.Active,
    statusLabelMsg: i18n.getString(_TL_('Active')),
  };
}
